// 더미 기준 데이터 — 그룹 → 카테고리 → 리소스 3단 구조. 캘린더 뷰의 행, 스프레드시트 뷰의 행으로 쓴다.

export interface Group {
  id: string;
  name: string;
}

export const GROUPS: Group[] = [
  { id: 'a', name: '그룹 A' },
  { id: 'b', name: '그룹 B' },
  { id: 'c', name: '그룹 C' },
  { id: 'd', name: '그룹 D' },
];

export interface Category {
  id: string;
  groupId: string;
  name: string;
  /** 스프레드시트 뷰의 기본값 */
  baseValue: number;
}

export interface Resource {
  id: string;
  groupId: string;
  categoryId: string;
  /** 표시용 코드 — 예: A-01 */
  code: string;
}

const CATEGORY_TEMPLATES = [
  { key: '1', name: '카테고리 1', baseValue: 62_000 },
  { key: '2', name: '카테고리 2', baseValue: 71_000 },
  { key: '3', name: '카테고리 3', baseValue: 48_000 },
];

export const CATEGORIES: Category[] = GROUPS.flatMap((group, groupIndex) =>
  CATEGORY_TEMPLATES.map((template) => ({
    id: `${group.id}-${template.key}`,
    groupId: group.id,
    name: template.name,
    baseValue: template.baseValue + groupIndex * 3_000,
  })),
);

/** 그룹마다 카테고리별 리소스 4개 — 코드는 그룹 안에서 01부터 차례로 */
export const RESOURCES: Resource[] = GROUPS.flatMap((group) =>
  CATEGORIES.filter((category) => category.groupId === group.id).flatMap(
    (category, categoryIndex) =>
      Array.from({ length: 4 }, (_, i) => ({
        id: `${category.id}-${String(i + 1)}`,
        groupId: group.id,
        categoryId: category.id,
        code: `${group.id.toUpperCase()}-${String(categoryIndex * 4 + i + 1).padStart(2, '0')}`,
      })),
  ),
);

const groupById = new Map(GROUPS.map((group) => [group.id, group]));
const resourceById = new Map(RESOURCES.map((resource) => [resource.id, resource]));
const categoryById = new Map(CATEGORIES.map((category) => [category.id, category]));

export const getGroup = (id: string) => groupById.get(id);
export const getResource = (id: string) => resourceById.get(id);
export const getCategory = (id: string) => categoryById.get(id);

/** "그룹 A · A-01" */
export function resourceLabel(resourceId: string) {
  const resource = getResource(resourceId);
  if (!resource) {
    return '-';
  }
  return `${getGroup(resource.groupId)?.name ?? ''} · ${resource.code}`;
}
